import script from "./TheSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./TheSidebar.vue?vue&type=script&setup=true&lang=ts"

import "./TheSidebar.vue?vue&type=style&index=0&id=4f5dd1b3&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f5dd1b3"]])

export default __exports__